import { genererObjectErrorAdresse, getErrorsAdresse } from '@/services/general/validations';
import { POINT_VENTE } from '@/configuration/clientConf';

export function genererObjectErrorTiers() {
  return {
    tiersParent: false,
    nomCommercial: false,
    siren: false,
    adresseError: false,
    adressePostale: genererObjectErrorAdresse(),
    applicationTva: false,
  };
}

export function isInvalidClient(tiers, error = genererObjectErrorTiers()) {
  error.nomCommercial = !tiers.nomCommercial;
  error.adressePostale = getErrorsAdresse(tiers.adressePostale);
  error.applicationTva = !tiers.applicationTva || !tiers.applicationTva.length;
  if (tiers.typologie === POINT_VENTE) {
    error.tiersParent = !tiers.tiersParentId;
  }
  if (tiers.typologie !== POINT_VENTE) {
    error.adressePostale.latitude = false;
    error.adressePostale.longitude = false;
  }
  error.siren = !tiers.prospect && !tiers.siren;
  error.adresseError = Object.values(error.adressePostale).some(Boolean);
  return Object.values(error).filter(el => typeof el === 'boolean').some(Boolean);
}
